import React from 'react';
import {useState} from 'react';
import {connectDynamic} from 'go/components/dynamic/dynamicComponent';
import {connect} from 'react-redux';
import _ from 'lodash';
import {AssignSubmitWrapper} from 'go/components/dynamic/modules/form/submitWrappers/AssignSubmitWrapper';
import ApiActions from 'go/actions/api';
import {withRouter} from 'react-router-dom';
import {compileContent, getTimestampNowISO} from 'common/utils';
import REST from 'go/requests/rest';
import {produce} from 'immer';
import {ASSOCIATED_ENTITY_STATUSES} from 'app-ui-componentlibrary/dist/common/constants';
import {ContentDispatch} from 'framework';

export const AssignSubmitButton = (props) => {
  const {
    token,
    saveEntitySessionData,
    assignTask,
    unassignTask,
    taskId,
    rerouteOnSubmit,
    entityId,
    organizationId,
    author,
    comments,
    childSubmitButton,
    childSubmitButtonConfig,
    handleSubmit,
  } = props;

  const buttonConfig = _.has(childSubmitButtonConfig, 'type')
    ? childSubmitButtonConfig
    : {type: childSubmitButton || 'DynamicSubmitButton'}; // something wrong with this when no childSubmitConfig or childSubmitButton

  const propsToPass = {
    ...props,
    childSubmitButton: undefined, // prevent child from rendering itself infinitely when passed childSubmitButton
    childSubmitButtonConfig: _.get(buttonConfig, 'childSubmitButtonConfig'),
    config: {
      ...props.config,
      ...buttonConfig,
    },
  };

  return (
    <AssignSubmitWrapper
      token={token}
      handleSubmit={handleSubmit}
      saveEntitySessionData={saveEntitySessionData}
      assignTask={assignTask}
      unassignTask={unassignTask}
      taskId={taskId}
    >
      {(updateHandleSubmit, ...otherArgs) => (
        <ContentDispatch
          {...propsToPass}
          {...otherArgs}
          handleSubmit={updateHandleSubmit}
        />
      )}
    </AssignSubmitWrapper>
  );
};

export const mapStateToProps = (state, props) => {
  const entitiesToSave = _.get(props, 'entitiesToSave', []);
  const entities = _.map(entitiesToSave, (entity) => ({
    entity: _.get(state.dynamicComponent, entity.entityDataPath),
    entityDataPath: entity.entityDataPath,
    entityType: entity.entityType,
    toChange: entity.toChange,
  }));
  const data = {
    token: _.get(state, 'auth.token'),
    entities,
    taskId: _.get(state, 'dynamicComponent.context.workflowTask.task.id'),
    entityId: _.get(state, 'dynamicComponent.data.entityId'),
    organizationId: _.get(state, 'dynamicComponent.data.organizationId'),
    author: _.get(state, 'auth.loginName'),
    comments: _.get(
      state,
      'dynamicComponent.data.payload.reviewPanel.finalReview.comments'
    ),
  };

  return data;
};

export const mapDispatchToProps = (dispatch) => {
  return {
    assignTask: (id, token) => {
      const action = ApiActions.tasks.assignTask(id, token);
      const res = dispatch(action);
      return res;
    },
    unassignTask: (id, token) => {
      const action = ApiActions.tasks.unassignTask(token, id);
      const res = dispatch(action);
      return res;
    },
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(connectDynamic(AssignSubmitButton))
);
